import { EditIcon } from '@chakra-ui/icons'
import { CircularProgress, HStack, IconButton, Text } from '@chakra-ui/react'
import { USER_ROLES, UserRoleItem, WithId } from '@hb/shared'
import { forwardRef, useMemo } from 'react'
import { useDocument } from '../../backend/db/hooks/useDocument'
import { SearchUsers, SearchUsersRef, UserSearchResult } from './SearchUsers'

interface SelectUserProps {
  patientId: string | null
  onSelect: (id: string) => void
  placeholder?: string
  userTypeName?: string
}

export const SelectUser = forwardRef<SearchUsersRef, SelectUserProps>(
  ({ patientId, onSelect, placeholder, userTypeName }, ref) => {
    const { data: user, loading } = useDocument<UserRoleItem>(USER_ROLES, patientId, !!patientId)

    const userWithId = useMemo<WithId<UserRoleItem> | null>(() => {
      if (!user || !patientId) return null
      return { ...user, id: patientId }
    }, [user, patientId])

    if (patientId) {
      if (loading) {
        return (
          <HStack w="100%" justify="center" py={2}>
            <CircularProgress size="24px" isIndeterminate />
          </HStack>
        )
      }

      if (!userWithId) {
        return <Text color="red.600">Unable to find user with id {patientId}</Text>
      }

      return (
        <UserSearchResult
          user={userWithId}
          onClick={() => {}}
          rightItem={
            <IconButton
              aria-label="Edit user selection"
              icon={<EditIcon />}
              size="sm"
              onClick={() => onSelect(null as any)}
              borderRadius="full"
            />
          }
        />
      )
    }

    return (
      <SearchUsers
        ref={ref}
        onSelect={onSelect}
        placeholder={placeholder}
        userTypeName={userTypeName}
      />
    )
  },
)
